import React, { useState,useEffect } from "react";
import { useSelector, useDispatch,shallowEqual } from "react-redux";
import {Link,useNavigate} from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { withStyles } from "@mui/styles";
import { firstActiveRoute } from "./NavigationBar/constant";
import UserProfilePopUp from "./UserProfilePopUp";
import { useStyles } from "./styles";
import {clinicActions,onClinicChange} from "@redux/actionCreators"
import { loginActions } from "@redux/actionCreators/UserActions";
import * as loaderActions from "@redux/actionCreators/LoaderActions";
import { GlobalRoutePath } from "@router/constants";
import {SettingsRoutePath,activeSettingsNavLinks} from "@settings/constants"
import {extractPrivileges} from "@components/PermissionContext"
import MFAConfig from "@components/UserProfile/MFAConfig";
import SvgIcon from "@common/SvgIcon";
import {SHOW_GLOBAL_ALERT} from "@utils/Events/constants";
import ClinicSelector from "./ClinicSelector";
import SettingsMenu from "./SettingsMenu";


const LoggedInActions = ({ classes,activeLinks,showClinicName,useDefaultClinic }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userClinics = useSelector(state => state.clinicReducer.userClinics,shallowEqual);
  const mfaSetupPending = useSelector(state => state.userReducer.mfaSetupPending,shallowEqual);
  const defaultClinic = useSelector(state => state.userReducer.defaultClinic,shallowEqual);
  const selectedClinicId = useSelector(state => state.clinicReducer.selectedClinicId,shallowEqual);
  const profilePicURL = useSelector(state => state.userReducer.profilePicURL,shallowEqual);
  const userRole = useSelector(state => state.userReducer.userRole,shallowEqual);
  const clinicMap = useSelector(state => state.clinicReducer.clinicMap,shallowEqual);
  const userPreferences = useSelector(state => state.userReducer.userPreferences,shallowEqual);
  const userClinicPermissions = useSelector(state => state.userReducer.userPermissionsBasedOnClinic,shallowEqual);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const confirmLogout = (e)=>{
      e.preventDefault();
      _app.events.trigger(SHOW_GLOBAL_ALERT,{title:<Box sx={{display:'flex',flexDirection:'column',alignItems:'center'}}><SvgIcon icon="/static/images/logout.png" size="extra-large"/>Are you sure you want to logout?</Box>,cancelText:'Cancel', okText:"Yes, log me out",onOkClick:handleSignout})
  }
  const handleSignout = async (e) => {
    e.preventDefault();
    await dispatch(loginActions.signout);
    //navigate(GlobalRoutePath.HOME.path);
  };
  useEffect(()=>{
    !defaultClinic && selectedClinicId && updateDefaultClinic(selectedClinicId); 
  },[selectedClinicId])

  const handleProfileIconClick = () => {
    setShowProfilePopup(!showProfilePopup);
  };
  const updateDefaultClinic = async (clinicId)=>{
    try{
      console.log("update clinic",clinicId);
      await loginActions.resetUserContext({cid:clinicId},false);
      useDefaultClinic && await dispatch(loginActions.updateUserCustomAttributes({defaultClinic:clinicId}));
    }catch(e){
      console.log('updateUserCustomAttributes failed',e);
    }
  }
  const getActivePages = (clinicId=selectedClinicId,all=true)=>{
    const {privileges} = extractPrivileges(userClinicPermissions,userRole,clinicId);
    const {availableLinks} = firstActiveRoute(privileges);
    const sProps = {privileges,activeLinks,products:clinicMap[clinicId]?.products}
    all && (sProps.excludes = [])
    const settingsLinks = activeSettingsNavLinks(sProps);
    const links = all?[...availableLinks,...settingsLinks]:[...settingsLinks];
    return activeLinks?links.filter(l=>activeLinks.includes(l.id)):links;
  }
  const onClinicSwitch = async ({clinicId,lp,changed,savePref,useAttributes})=>{
    //const {IHP_CHANNEL,CHANNEL_EVENTS,appContext} = loginActions
    const prf = {lp:savePref?lp:null};
    useAttributes && await dispatch(loginActions.setUserAttributes(useAttributes));
		if(changed){
      dispatch(loaderActions.startAppLoader({title: 'Loading the Clinic configurations', content:'Please wait while loading the Clinic configurations...'}));
      dispatch(onClinicChange(clinicId));
      await updateDefaultClinic(clinicId);
      await dispatch(clinicActions.updateUserSelectedClinicId(clinicId));
    }
    else{
      prf.cid = clinicId;
    }
    loginActions.setUserPref(prf);
    navigate(lp || GlobalRoutePath.LANDING.path);
    dispatch(loaderActions.stopAppLoader());
    //setTimeout(()=>IHP_CHANNEL.postMessage({event:CHANNEL_EVENTS.CLINIC_SWITCH,uid:appContext.uid,data:{clinicId}}),1000);
  }


  return (
    <div className={classes.loggedInActionsContainer}>
      {mfaSetupPending && <MFAConfig mfaRequired popup/>}
      {!!userClinics.length && <ClinicSelector 
        userClinics={userClinics.sort((a,b)=>a.display_name.localeCompare(b.display_name))} 
        selectedClinicId={selectedClinicId} 
        onClinicSwitch={onClinicSwitch} 
        getActivePages={getActivePages} 
        userKey={loginActions.appContext.user} 
        showClinicName={showClinicName}
        userPreferences={userPreferences}/>}
      <div className={classes.iconsContainer}>
        {/* <SvgIcon className={classes.NotificationsIcon} icon="/static/images/notifications.svg"/> */}
        <Avatar
              className={classes.AccountCircleIcon}
              src={profilePicURL || '/static/images/avatar-default.svg'}
              onClick={()=>navigate(GlobalRoutePath.USER_PROFILE.path)}
            />
        <SettingsMenu classes={classes} settingsItems={getActivePages(selectedClinicId,false)}/>
        {(!activeLinks || activeLinks.includes("help")) && <div className="iconList">
          <Link to={SettingsRoutePath.HELP.fullPath} title="Help Center">
            <SvgIcon icon="/static/images/help.svg" size="medium" />
          </Link>
        </div>}      
        <div className="iconList">
          <a href="#" onClick={confirmLogout} title="Logout">
            <SvgIcon icon="/static/images/logout.png" size="medium"/>
            
          </a>  
        </div>    
        {showProfilePopup && <UserProfilePopUp show={showProfilePopup} handleClose={() => setShowProfilePopup(false)} />}
      </div>
    </div>
  );
};

export default withStyles(useStyles)(LoggedInActions);
